import { type AnyAction, configureStore, type ThunkAction } from '@reduxjs/toolkit';

import { listenerMiddlewareInstance } from './listener-middleware';
// TODO: Cannot import from here until we have updated
// all of the `RootState` imports.
// import { rootReducer } from './combined-reducers';
import { rootReducer } from './reducers';

// TODO: Remove these one-by-one as you refactor away
// all the old code / unprotected state mutations.
const tempIgnoredPaths = [
    'adminInfo',
    'artifacts',
    'auth',
    'crypto',
    'dashboard',
    'display',
    'editions',
    'emoji',
    'loader',
    'nftManager',
    'nft',
    'notifications',
    'organizations',
    'partnerIntegrations',
    'picker',
    'transfers',
    'twoFactorAuth',
    'userEmojis',
    'user',
    'waitlist',
];

export function deferredReduxStore() {
    return configureStore({
        reducer: rootReducer,
        devTools: { trace: true, traceLimit: 25 },

        // TODO: Remove this once we are ready to resolve
        // each non-serializable value violation.
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                immutableCheck: {
                    ignoredPaths: tempIgnoredPaths,
                },
                serializableCheck: false,
            }).prepend(listenerMiddlewareInstance.middleware),
    });
}

export type DeferredStore = ReturnType<typeof deferredReduxStore>;
export type RootState = ReturnType<DeferredStore['getState']>;
export type AppDispatch = DeferredStore['dispatch'];
export type AppThunk<T = void> = ThunkAction<T, RootState, void, AnyAction>;
export type AppThunkPromise<T> = AppThunk<Promise<T>>;
